import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// TypeScript interface for model state
interface ModelState {
  selectedModel: string;
  thinkingMode: boolean;
  supportedModels: string[];
}

// Supported models including GLM-4.5
const SUPPORTED_MODELS = [
  'gpt-5-mini',
  'gpt-5',
  'gpt-4o',
  'glm-4.5'
] as const;

const initialState: ModelState = {
  selectedModel: 'gpt-5-mini', // Updated to match MenuItem values
  thinkingMode: false, // Default to false for performance
  supportedModels: SUPPORTED_MODELS as unknown as string[],
};

const modelSlice = createSlice({
  name: 'model',
  initialState,
  reducers: {
    setModel: (state, action: PayloadAction<string>) => {
      state.selectedModel = action.payload;
    },
    toggleThinkingMode: (state, action: PayloadAction<boolean>) => {
      state.thinkingMode = action.payload;
    },
  },
});

export const { setModel, toggleThinkingMode } = modelSlice.actions;

// Export types for use in components
export type { ModelState };
export { SUPPORTED_MODELS };

export default modelSlice.reducer;
